/* global axios */
import ApiClient from './ApiClient';

class BugReportCommentsAPI extends ApiClient {
  constructor() {
    super('bug_reports', { accountScoped: true });
  }

  index(bugReportId, { page = 1, perPage = 30 } = {}) {
    return axios.get(`${this.url}/${bugReportId}/bug_report_comments`, {
      params: { page, per_page: perPage },
    });
  }

  create(bugReportId, content) {
    return axios.post(`${this.url}/${bugReportId}/bug_report_comments`, {
      bug_report_comment: { content },
    });
  }
}

export default new BugReportCommentsAPI();
